import React, { useState, useEffect } from 'react';

export default function DateFilter({ value, operator, onChange }) {
  const [op, setOp] = useState(operator || 'igual');

  useEffect(() => { setOp(operator || 'igual'); }, [operator]);
  useEffect(() => {
    if (!value) setLocalVal({ desde: '', hasta: '' });
  }, [value]);
  const [localVal, setLocalVal] = useState(() => {
    if (op === 'entre' && value) {
      const parts = value.split(',');
      return { desde: parts[0] || '', hasta: parts[1] || '' };
    }
    return { desde: value || '', hasta: '' };
  });

  const handleOpChange = (e) => {
    const newOp = e.target.value;
    setOp(newOp);
    if (newOp === 'entre') {
      onChange(`${localVal.desde},${localVal.hasta}`, newOp);
    } else {
      onChange(localVal.desde, newOp);
    }
  };

  const handleValueChange = (val, field) => {
    const updated = { ...localVal, [field]: val };
    setLocalVal(updated);
    if (op === 'entre') {
      onChange(`${updated.desde},${updated.hasta}`, op);
    } else {
      onChange(val, op);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <select className="cm-filter-select" value={op} onChange={handleOpChange}>
        <option value="igual">Igual</option>
        <option value="mayor_igual">Mayor e igual a</option>
        <option value="menor_igual">Menor e igual a</option>
        <option value="entre">Entre</option>
      </select>
      {op === 'entre' ? (
        <div style={{ display: 'flex', gap: 2 }}>
          <input
            className="cm-filter-input"
            type="date"
            value={localVal.desde}
            onChange={(e) => handleValueChange(e.target.value, 'desde')}
            style={{ width: '50%' }}
          />
          <input
            className="cm-filter-input"
            type="date"
            value={localVal.hasta}
            onChange={(e) => handleValueChange(e.target.value, 'hasta')}
            style={{ width: '50%' }}
          />
        </div>
      ) : (
        <input
          className="cm-filter-input"
          type="date"
          value={localVal.desde}
          onChange={e => handleValueChange(e.target.value, 'desde')}
        />
      )}
    </div>
  );
}
